import { useMemo } from "react";

import {
    IconTCash,
    IconTbancaire,
    IconAssurance,
    IconEsim,
    IconPrepayee,
    IconRecharegMobile,
    IconWallet,
    Iconfacture,
  } from "../assets/indexIcon";

export const useActionMap = () => {
  return useMemo(() => {
    const ListeActions = [
      {
        icon: IconTCash,
        type: "T.Cash",
        action: "transfer cash_pickup",
        distributionChannel: "cash_pickup",
      },
      {
        icon: IconTbancaire,
        type: "C.Compte",
        action: "transfer bank_account",
        distributionChannel: "bank_account",
      }, 
      {
        icon: IconAssurance,
        type: "S.Assurance",
        action: "hgj",
        distributionChannel: "",
      },
      {
        icon: IconEsim,
        type: "A.eSIM",
        action: "gfgh",
        distributionChannel: "",
      },
      {
        icon: IconPrepayee,
        type: "C.Prépayée",
        action: "ghf",
        distributionChannel: "",
      },
      {
        icon: IconRecharegMobile,
        type: "R. Mobile",
        action: "recharge",
        distributionChannel: "",
      },
      {
        icon: IconWallet,
        type: "T. Wallet",
        action: "fgh",
        distributionChannel: "",
      },
      {
        icon: Iconfacture,
        type: "P. Facture",
        action: "invoice",
        distributionChannel: "",
      },
    ];

    return Object.fromEntries(
      ListeActions.map((item) => [item.action, item])
    );
  }, []);
};